import { mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import Component from "./Node.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

const Section = Node.create({
    name: "section",
    group: "block list",
    content: "(paragraph|heading|button|image|form|signature|html|columns)+",

    atom: true,
    defining: true,

    addAttributes() {
        return createDefaultBlockForTipTap("section");
    },

    parseHTML() {
        return [
            {
                tag: "section",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        for (const key of Object.keys(HTMLAttributes)) {
            if (
                Array.isArray(HTMLAttributes[key]) ||
                typeof HTMLAttributes[key] === "object"
            ) {
                HTMLAttributes[key] = JSON.stringify(HTMLAttributes[key]);
            }
        }

        return ["section", mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(Component);
    },
});

export default Section;
